import {
  OUTPUT_BUILD_POLL_MS,
  OUTPUT_BUILD_POLL_SLOW_MS,
  OUTPUT_BUILD_POLL_STEADY_MS,
} from '@/features/delivery/config/constants';

const FAST_WINDOW_MS = 30_000;
const STEADY_WINDOW_MS = 2 * 60_000;
const activeSince = new WeakMap<object, number>();

/**
 * Poll an active build quickly at first, then back off while it remains active.
 *
 * The Query object is the lifecycle key: a terminal response clears its clock, so a later rebuild
 * starts at the fast interval again. A WeakMap avoids retaining queries after TanStack evicts them.
 * TanStack's default `refetchIntervalInBackground: false` skips background fetches while preserving
 * the interval, so polling resumes when the page becomes visible even though focus refetch is off.
 */
export function activeBuildPollInterval(query: object, active: boolean): number | false {
  if (!active) {
    activeSince.delete(query);
    return false;
  }

  const now = Date.now();
  const startedAt = activeSince.get(query) ?? now;
  activeSince.set(query, startedAt);

  const elapsed = now - startedAt;
  if (elapsed < FAST_WINDOW_MS) return OUTPUT_BUILD_POLL_MS;
  if (elapsed < STEADY_WINDOW_MS) return OUTPUT_BUILD_POLL_STEADY_MS;
  return OUTPUT_BUILD_POLL_SLOW_MS;
}
